import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({ name: 'imgFromBytes' })
export class ImgFromBytesPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) { }

  transform(src: string): SafeUrl {
    if (!src) return '';
    return this.domSanitizer.bypassSecurityTrustUrl(`data:image/png;base64,${src}`)
  }

}
